module.exports = __webpack_public_path__ + "static/graph-1-fc41c6a4e8d8402f11a9deae7c959a7e.svg";